/**
 * FAQ Accordion Functionality
 * Gerencia a abertura/fechamento dos itens do accordion de FAQ
 */

jQuery(document).ready(function ($) {
  $(".faq-question").on("click", function () {
    const $faqItem = $(this).closest(".faq-item");
    const $answer = $(this).siblings(".faq-answer");
    const $icon = $(this).find(".faq-icon");
    const isActive = $faqItem.hasClass("faq-active");

    if (isActive) {
      // Fechar o item ativo
      $faqItem.removeClass("faq-active");
      $answer.css("max-height", "0");
      $icon.removeClass("rotate-180");
      $(this).attr("aria-expanded", "false");
    } else {
      // Lê scrollHeight antes de qualquer modificação no DOM para evitar forced reflow
      const targetHeight = $answer.get(0).scrollHeight + "px";

      // Fechar todos os outros itens
      $(".faq-item").removeClass("faq-active");
      $(".faq-answer").css("max-height", "0");
      $(".faq-icon").removeClass("rotate-180");
      $(".faq-question").attr("aria-expanded", "false");

      // Abrir o item clicado
      $faqItem.addClass("faq-active");
      $answer.css("max-height", targetHeight);
      $icon.addClass("rotate-180");
      $(this).attr("aria-expanded", "true");
    }
  });

  // Ajustar altura do primeiro item ao carregar
  $(".faq-item.faq-active .faq-answer").each(function () {
    $(this).css("max-height", $(this).get(0).scrollHeight + "px");
  });
});
